var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { Button, Checkbox, Chip } from 'syf-component-library/ui/atoms';
import { NotificationBar } from 'syf-component-library/ui/patterns';
import { StyledCheckbox } from 'syf-component-library/ui/atoms/Checkbox/subcomponents';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NotificationStatus } from '../../config';
import { colors, theme } from '../../../../theme';
import { SupportedLanguage } from '../../../../const/alertsConfig';
import query from '../../../../mediaQueries';
export var DeliveryMethodWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  gap: ", ";\n  margin-bottom: 32px;\n  @media ", " {\n    margin-bottom: 40px;\n    flex-direction: ", ";\n    gap: ", ";\n  }\n"], ["\n  display: flex;\n  gap: ", ";\n  margin-bottom: 32px;\n  @media ", " {\n    margin-bottom: 40px;\n    flex-direction: ", ";\n    gap: ", ";\n  }\n"])), function (_a) {
    var $isEditEnabled = _a.$isEditEnabled;
    return $isEditEnabled ? '28px' : '80px';
}, query.lessThanMedium, function (_a) {
    var lang = _a.lang;
    return lang === SupportedLanguage.ES && 'column';
}, function (_a) {
    var lang = _a.lang;
    return lang === SupportedLanguage.ES && '18px';
});
export var DeliveryIcons = styled(Chip)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &:hover {\n    background-color: ", ";\n  }\n  color: ", ";\n  background-color: ", ";\n  border: ", ";\n  box-shadow: ", ";\n  padding: ", ";\n  width: ", ";\n  height: 24px;\n  line-height: 24px;\n  letter-spacing: 0;\n  font-weight: ", ";\n"], ["\n  &:hover {\n    background-color: ", ";\n  }\n  color: ", ";\n  background-color: ", ";\n  border: ", ";\n  box-shadow: ", ";\n  padding: ", ";\n  width: ", ";\n  height: 24px;\n  line-height: 24px;\n  letter-spacing: 0;\n  font-weight: ", ";\n"])), function (_a) {
    var $isEnrolled = _a.$isEnrolled, $isEditEnabled = _a.$isEditEnabled;
    if ($isEditEnabled) {
        return $isEnrolled ? theme.button.primary.hover : colors.cadetGray;
    }
    return colors.white;
}, function (_a) {
    var $isEnrolled = _a.$isEnrolled, $isEditEnabled = _a.$isEditEnabled;
    if ($isEditEnabled) {
        return $isEnrolled ? colors.white : colors.black;
    }
    if ($isEnrolled) {
        return colors.darkBlue;
    }
    return colors.black;
}, function (_a) {
    var $isEnrolled = _a.$isEnrolled, $isEditEnabled = _a.$isEditEnabled;
    return $isEnrolled && $isEditEnabled ? colors.darkBlue : colors.white;
}, function (_a) {
    var $isEditEnabled = _a.$isEditEnabled;
    return $isEditEnabled ? "1px solid ".concat(colors.lightGrey) : 'none';
}, function (_a) {
    var $isEditEnabled = _a.$isEditEnabled;
    return $isEditEnabled
        ? "0 3px 3px 0 ".concat(theme.chipIcon.borderShadowMedium, ", 0 3px 4px 0 ").concat(theme.binart.disableBackground, ", 0 1px 8px 0 ").concat(theme.chipIcon.borderShadowLight)
        : 'none';
}, function (_a) {
    var $isEditEnabled = _a.$isEditEnabled;
    return $isEditEnabled ? '18px 8px' : '0px';
}, function (_a) {
    var $isEditEnabled = _a.$isEditEnabled, lang = _a.lang;
    return $isEditEnabled && (lang === SupportedLanguage.ES ? '200px' : '150px');
}, function (_a) {
    var $isEditEnabled = _a.$isEditEnabled, $isEnrolled = _a.$isEnrolled;
    return !$isEditEnabled && $isEnrolled ? 'bold' : 'normal';
});
export var CustomButton = styled(Button)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  line-height: 1.14;\n  margin: 0;\n  background-color: ", ";\n  min-width: ", ";\n  min-height: 48px;\n  font-family: inherit;\n  &:disabled {\n    background-color: ", ";\n  }\n"], ["\n  line-height: 1.14;\n  margin: 0;\n  background-color: ", ";\n  min-width: ", ";\n  min-height: 48px;\n  font-family: inherit;\n  &:disabled {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var buttonType = _a.buttonType;
    return buttonType === 'primary' ? theme.button.background : colors.white;
}, function (_a) {
    var buttonType = _a.buttonType;
    return buttonType === 'primary' ? '225px' : '200px';
}, colors.lightGrey);
export var ButtonWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row-reverse;\n  @media ", " {\n    display: grid;\n  }\n"], ["\n  display: flex;\n  flex-direction: row-reverse;\n  @media ", " {\n    display: grid;\n  }\n"])), query.lessThanMedium);
export var ChipIcon = styled(FontAwesomeIcon)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n  height: 18px;\n  border-radius: 10px;\n"], ["\n  background-color: ", ";\n  color: ", ";\n  height: 18px;\n  border-radius: 10px;\n"])), function (_a) {
    var $isEnrolled = _a.$isEnrolled, $isEditEnabled = _a.$isEditEnabled;
    if ($isEditEnabled) {
        return colors.white;
    }
    return $isEnrolled ? colors.darkBlue : colors.white;
}, function (_a) {
    var $isEnrolled = _a.$isEnrolled, $isEditEnabled = _a.$isEditEnabled;
    if ($isEditEnabled) {
        return $isEnrolled ? colors.darkCyanBlue : colors.black;
    }
    return $isEnrolled ? colors.white : colors.black;
});
export var ButtonContainer = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  gap: 30px;\n  @media ", " {\n    flex-direction: column-reverse;\n    gap: 24px;\n  }\n"], ["\n  display: flex;\n  gap: 30px;\n  @media ", " {\n    flex-direction: column-reverse;\n    gap: 24px;\n  }\n"])), query.lessThanMedium);
export var CustomCheckBox = styled(Checkbox)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  color: ", ";\n  border: 1px solid ", ";\n  background-color: ", ";\n  padding: 16px;\n  border-radius: 6px;\n  margin-bottom: 32px;\n  margin-top: 24px;\n  label div {\n    top: 3px;\n  }\n  ", " {\n    > svg {\n      width: 100%;\n      height: 100%;\n    }\n  }\n  @media ", " {\n    width: auto;\n    height: auto;\n  }\n"], ["\n  color: ", ";\n  border: 1px solid ", ";\n  background-color: ", ";\n  padding: 16px;\n  border-radius: 6px;\n  margin-bottom: 32px;\n  margin-top: 24px;\n  label div {\n    top: 3px;\n  }\n  ", " {\n    > svg {\n      width: 100%;\n      height: 100%;\n    }\n  }\n  @media ", " {\n    width: auto;\n    height: auto;\n  }\n"])), colors.mediumGrey, colors.slateGray, colors.cadetGray, StyledCheckbox, query.lessThanMedium);
export var NotificationBarIcon = styled(FontAwesomeIcon)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n  border-radius: 15px;\n"], ["\n  background-color: ", ";\n  color: ", ";\n  border-radius: 15px;\n"])), function (_a) {
    var type = _a.type;
    return type === NotificationStatus.SUCCESS
        ? theme.notificationBar.success.iconBackground
        : theme.notificationBar.error.iconBackground;
}, function (_a) {
    var type = _a.type;
    return type === NotificationStatus.SUCCESS
        ? theme.notificationBar.success.icon
        : theme.notificationBar.error.icon;
});
export var NotificationStatusBar = styled(NotificationBar)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  border-radius: 10px;\n  background-color: ", ";\n  border: 1px solid\n    ", ";\n"], ["\n  border-radius: 10px;\n  background-color: ", ";\n  border: 1px solid\n    ", ";\n"])), function (_a) {
    var type = _a.type;
    return type === NotificationStatus.SUCCESS
        ? theme.notificationBar.success.background
        : theme.notificationBar.error.background;
}, function (_a) {
    var type = _a.type;
    return type === NotificationStatus.SUCCESS
        ? theme.notificationBar.success.border
        : theme.notificationBar.error.border;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
